<script>
import Item from './CheckoutListItem';

export default {
  components: {
    Item,
  },

  mounted () {
    this.handleSearch();
  },

  data: () => ({
    query: '',

    checkouts: [
      //
    ],
  }),

  methods: {
    handleSearch: _.debounce(function () {
      const {
        query,
      } = this;

      this.$http.get(`/form/checkout/search?q=${query}`)
        .then(({ data }) => {
          this.checkouts = data;
        });
    }, 250),
  },
};
</script>

<template>
  <div
    class="bdk-w-full bdk-h-full bdk-preflight"
  >
    <div
      class="bdk-mt-1 bdk-relative bdk-flex bdk-items-center"
    >
      <input
        type="text"
        name="search"
        v-model="query"
        @input="handleSearch"
        :placeholder="__('Digite para pesquisar um Checkout')"
        class="form-input bdk-shadow-sm focus:bdk-ring-indigo-500 focus:bdk-border-indigo-500 bdk-block bdk-w-full bdk-pr-12 sm:bdk-text-sm bdk-border-gray-300 bdk-rounded-md"
      />

      <div
        class="bdk-absolute bdk-flex bdk-items-center bdk-inset-y-0 bdk-right-0 bdk-flex bdk-py-1.5 bdk-pr-1.5"
      >
        <svg class="bdk-h-4 bdk-w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
    </div>

    <div
      class="bdk-flex bdk-flex-col bdk-mt-5 bdk-pt-5 bdk-border-t bdk-border-gray-200"
    >
      <Item
        v-bind="checkout"
        :key="checkout.hashid"
        v-for="checkout in checkouts"
        @edit="$emit('edit', checkout)"
        @selected="$emit('selected', checkout)"
      />
    </div>
  </div>
</template>
